import { StatusIcon, type StatusIconKind } from "@/shared/status/status-icon";

export const TASK_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  requested: "Requested",
  ready: "Todo",
  "in-progress": "In Progress",
  "on-hold": "On Hold",
  completed: "Completed",
  cancelled: "Cancelled",
  failed: "Failed",
};

// `requested` shares Todo's glyph: waiting on the assignee to accept reads the
// same as waiting on them to start, and the app never surfaces the difference.
const TASK_STATUS_ICONS: Record<string, StatusIconKind> = {
  draft: "draft",
  requested: "todo",
  ready: "todo",
  "in-progress": "active",
  "on-hold": "paused",
  completed: "done",
  cancelled: "cancelled",
  failed: "error",
};

export function TaskStatusIcon({ status, size }: { status: string | undefined; size?: number }) {
  return <StatusIcon status={status ? TASK_STATUS_ICONS[status] : undefined} size={size} />;
}
